import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { SessionService } from 'src/app/services/session.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MachineSelectedGuard implements CanActivate {
  
  constructor(private sessionService: SessionService,private router: Router){
  }


  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if(this.sessionService.currentMachineValue!=undefined && this.sessionService.currentMachineValue!=null)
        return true;
      else{
        return this.router.parseUrl("/dashboard");
      }
  }
}
